import React, { useEffect } from 'react'
import moment from 'moment'

import { Box, Grid, Typography } from '@material-ui/core'

import useProfileContext from 'src/context/ProfileContext'
import { Damaged } from 'src/api/models'
import { Barcode } from '../Barcode'

interface Props {
  obj: Damaged
  onReadyToPrint?: () => void
}

export const DamagedLabel = ({ obj, onReadyToPrint }: Props) => {
  const barcode = { barcode: obj.guid, type: 'datamatrix', displayName: '' }
  const { profile } = useProfileContext()

  useEffect(() => {
    onReadyToPrint?.()
  }, [onReadyToPrint])

  return (
    <div className="always-page-break">
      <Box pl={3} pt={3} className="print-page">
        <Grid container justify="center" alignItems="center" spacing={2}>
          <Grid item xs={4}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item container xs={8} justify="center" alignItems="center" spacing={2}>
            <Grid item xs={2}>
              <obj.icon fontSize="large" />
            </Grid>
            <Grid item xs={10}>
              <Typography variant="h1" color="error" align="left">
                DAMAGED
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h4">SKU: {obj.sku?.sku}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h4">Product: {obj.product?.name}</Typography>
            </Grid>
            {!!obj.batch &&<Grid item xs={12}>
              <Typography variant="h4">{obj.batch?.name}</Typography>
            </Grid>}
          </Grid>
          <Grid item xs={12} container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h1">{obj.guid}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>Printed on {moment().format('lll')}</Typography>
            </Grid>
            {!!profile && (
              <Grid item xs={12}>
                <Typography>By {`${profile.fullName} <${profile.email}>`}}</Typography>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}
